import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CurrentInfoService } from 'src/app/services/current-info.service';
import { CurrentOrderService } from 'src/app/services/current-order.service';
import { InitializationService } from 'src/app/services/initialization.service';
import { LocaleService } from 'src/app/services/locale.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { WorkWeekService } from 'src/app/services/work-week.service';
import { AlertDialogComponent } from '../dialogs/alert-dialog/alert-dialog.component';

@Component({
  selector: 'app-order-base-data',
  templateUrl: './order-base-data.component.html',
  styleUrls: ['./order-base-data.component.scss']
})
export class OrderBaseDataComponent implements OnInit 
{
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) 
  {
    $event.returnValue =true;
  }

  scheduled:boolean = false;
  paymode:number = -1;
  needschange:number = -1;
  public changefor:number = 0;
  public scheduletime:string = '00:00';
  currentPriceString:string = '';
  currentOrderValue:number = 10;
  ordermode:number = -1;
  
  constructor(
    public alertDialog: MatDialog,
    private workweekservice: WorkWeekService,
    private currentorderservice: CurrentOrderService,
    private currentinfoservice: CurrentInfoService,
    private initializationservice: InitializationService,
    private route: ActivatedRoute,
    private router: Router,
    private navigationservice: NavigationService,
    private localeserice: LocaleService,
  ) { }

  ngOnInit(): void 
  {
    var appname = String(this.route.snapshot.paramMap.get('appname'));

    if(!this.initializationservice.checkApp(appname))
    {
      this.initializationservice.reloadApp(appname);

      return;
    }

    this.ordermode = this.currentorderservice.getOrderType();
    this.currentOrderValue = this.currentorderservice.getCurrentPrice(true, true);
    this.currentPriceString = this.currentorderservice.getCurrentPriceString(true, true);

    var baseData = this.currentorderservice.getBaseData();

    this.scheduled = baseData.scheduled;
    this.scheduletime = baseData.scheduledfor;
    this.paymode = baseData.paymode;
    this.needschange = baseData.needschange;
    this.changefor = baseData.changefor;
  }

  back()
  {
    this.navigationservice.back();
  }

  setScheduled(status:boolean)
  {
    this.scheduled = status;
  }

  setPaymode(mode:number)
  {
    this.paymode = mode;
  }

  setNeedsChange(status:number)
  {
    this.needschange = status;
  }

  check()
  {
    if(this.scheduled === true)
    {
      var currentDateTime = new Date();

      var scheduletimeString = this.scheduletime.split(':');

      var scheduledDateTime = new Date(currentDateTime.getFullYear(), currentDateTime.getMonth(), currentDateTime.getDate(), Number(scheduletimeString[0]), Number(scheduletimeString[1]), 0, 0);

      if(scheduledDateTime.valueOf() <= currentDateTime.valueOf())
      {
        {
          this.alertDialog.open(AlertDialogComponent, {
            height: 'fit-content',
            width: 'fit-content',
            data: 
            { 
              title:this.localeserice.instantTranslation("Dialogs.Alert.PastScheduleError.Title"), 
              detail:this.localeserice.instantTranslation("Dialogs.Alert.PastScheduleError.Detail"), 
              accept:this.localeserice.instantTranslation("Dialogs.Alert.PastScheduleError.Accept") }
          });

          return false;
        }
      }

      var currentWaitTimeMs = this.currentinfoservice.getMinutes(this.currentorderservice.getWaitTime()) * 60 * 1000;

      var readyDateTime = new Date(currentDateTime.valueOf() + currentWaitTimeMs);

      if(scheduledDateTime.valueOf() < readyDateTime.valueOf())
      {
        this.alertDialog.open(AlertDialogComponent, 
        {
          height: 'fit-content',
          width: 'fit-content',
          data: 
          { 
            title:this.localeserice.instantTranslation("Dialogs.Alert.ScheduleErrorTimeout.Title"), 
            detail:this.localeserice.instantTranslation("Dialogs.Alert.ScheduleErrorTimeout.Detail"), 
            accept:this.localeserice.instantTranslation("Dialogs.Alert.ScheduleErrorTimeout.Accept") 
          }
        });

        return false;
      }

      var dayOfTheWeek = currentDateTime.getDay();

      var dayStartTimeStringArray = this.workweekservice.getStartTimeString(dayOfTheWeek).split(':', 2);

      var dayStartDateTime = new Date();

      dayStartDateTime.setHours(Number(dayStartTimeStringArray[0]), Number(dayStartTimeStringArray[1]), 0, 0);

      var dayEndTimeStringArray = this.workweekservice.getEndTimeString(dayOfTheWeek).split(':', 2);

      var dayEndDateTime = new Date();

      dayEndDateTime.setHours(Number(dayEndTimeStringArray[0]), Number(dayEndTimeStringArray[1]), 0, 0);

      if(scheduledDateTime.valueOf() < dayStartDateTime.valueOf() || scheduledDateTime.valueOf() > dayEndDateTime.valueOf())
      {
        this.alertDialog.open(AlertDialogComponent, 
        {
          height: 'fit-content',
          width: 'fit-content',
          data: 
          { 
            title:this.localeserice.instantTranslation("Dialogs.Alert.ScheduleErrorClosed.Title"), 
            detail:this.localeserice.instantTranslation("Dialogs.Alert.ScheduleErrorClosed.Detail"), 
            accept:this.localeserice.instantTranslation("Dialogs.Alert.ScheduleErrorClosed.Accept") 
          }
        });

        return false;
      }
    }

    if(this.ordermode === 2 || this.ordermode === 4)
    {
      if(this.paymode > -1)
      {
        if(this.paymode === 0)
        {
          if(this.needschange > -1 )
          {
            if(this.needschange === 1 && this.changefor <= this.currentOrderValue)
            {
              this.alertDialog.open(AlertDialogComponent, 
              {
                height: 'fit-content',
                width: 'fit-content',
                data: 
                { 
                  title:this.localeserice.instantTranslation("Dialogs.Alert.ChangeErrorBigger.Title"), 
                  detail:this.localeserice.instantTranslation("Dialogs.Alert.ChangeErrorBigger.Detail"), 
                  accept:this.localeserice.instantTranslation("Dialogs.Alert.ChangeErrorBigger.Accept") 
                }
              });
    
              return false;
            }
          }
          else
          {
            this.alertDialog.open(AlertDialogComponent, 
            {
              height: 'fit-content',
              width: 'fit-content',
              data: 
              { 
                title:this.localeserice.instantTranslation("Dialogs.Alert.ChangeErrorDefine.Title"), 
                detail:this.localeserice.instantTranslation("Dialogs.Alert.ChangeErrorDefine.Detail"), 
                accept:this.localeserice.instantTranslation("Dialogs.Alert.ChangeErrorDefine.Accept") 
              }
            });

            return false;
          }
        }
      }
      else
      {
        this.alertDialog.open(AlertDialogComponent, 
        {
          height: 'fit-content',
          width: 'fit-content',
          data: 
              { 
                title:this.localeserice.instantTranslation("Dialogs.Alert.PaymentError.Title"), 
                detail:this.localeserice.instantTranslation("Dialogs.Alert.PaymentError.Detail"), 
                accept:this.localeserice.instantTranslation("Dialogs.Alert.PaymentError.Accept") 
              }
        });
        return false;
      }
    }

    return true;
  }

  goOn()
  {
    if(this.check())
    {
      var baseData = {
        scheduled: this.scheduled, 
        scheduledfor: this.scheduletime,
        paymode: this.paymode,
        needschange: this.needschange,
        changefor : this.changefor
      }

      this.currentorderservice.setBaseData(baseData)

      var appname = String(this.route.snapshot.paramMap.get('appname'));

      this.router.navigateByUrl('/' + appname + '/orderresume');
    }
  }
}
